import { render, staticRenderFns } from "./NewHook.vue?vue&type=template&id=6f7efbe2&"
import script from "./NewHook.vue?vue&type=script&lang=js&"
export * from "./NewHook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports